<div
  class="topDiv"
  [style.background-color]="backgroundColorScreen"
  style="padding: 5px"
>
  <div class="agGridOuterDiv">
    <!-- <div class="row topRowMargins headerStyle">
      <div class="dataset col-lg-12" style="margin-top: 1%">
        Mapping Attributes
      </div>
    </div> -->
      <div class="row topRowMargins headerStyle" style="
          margin-right: 0;
          margin-left: 0;
          margin-top: 3%;
          ">
          <label i18n="@@spmsUserReg" class="textColour">Attributes Mapping</label>
          <span class="example-spacer"></span>
             <nav mat-tab-nav-bar mat-stretch-tabs>
            <a
              mat-tab-link
              *ngFor="let link of navLinks"
              [routerLink]="getRouterLink(link)"
              [queryParams]="getQueryParams(link.label)"
              [active]="link.label === 'Attributes Mapping'"
              style="min-width:130px; opacity: 1;"
              rel="noopener"
            >
              {{ link.label }}
            </a>
          </nav>
        </div>

    <div style="margin-top: 25px">
      <form novalidate [formGroup]="validations_form">
        <div class="row">
          <!-- <div class="col-lg-2"></div> -->
          <div class="col-lg-6">
           <mat-form-field appearance="outline" class="mapped-object-field">
            <mat-label>Select Mapped Objects</mat-label>

            <mat-select
              panelClass="mapped-object-panel"
              (selectionChange)="onObjectSelectionChange($event)"
              [(ngModel)]="selectedObjects"
              formControlName="objects"
              ngDefaultControl
              required>

              <mat-option disabled class="mapped-header">
                <div class="mapped-row">
                  <span>Source</span>
                  <span class="dash">-</span>
                  <span>Target</span>
                </div>
              </mat-option>

              <mat-option
                *ngFor="let data of mappingConfigurationData"
                [value]="data.mappingconfigurationid"
                class="mapped-option">

                <div class="mapped-row">
                  <span class="cell-text">{{ data.stageobjectlabel }}</span>
                  <span class="dash">-</span>
                  <span class="cell-text">{{ data.targetobjectlabel }}</span>
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>
          </div>
        </div>
    <div class="row" style="padding-bottom: 1.34375em;
    margin-bottom: .25em;">
      <!-- <div class="col-lg-2"></div> -->
      <div class="col-lg-6">
        <div
          class="seperateDiv"
          style="overflow: hidden; flex-grow: 1; padding: 0"
        >
          <ag-grid-angular
            class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin"
            style="width: 100%"
            [columnDefs]="columnDefsForSource"
            [animateRows]="true"
            [defaultColDef]="defaultColDef"
            [suppressPaginationPanel]="true"
            [rowMultiSelectWithClick]="true"
            [rowSelection]="rowSelectionForSource"
            [rowHeight]="35"
            [headerHeight]="35"
            [enableBrowserTooltips]="true"
            [floatingFiltersHeight]="45"
            [enableRangeSelection]="true"
            [debug]="true"
            (gridReady)="onGridReadyForSourceAttributes($event)"
            (rowSelected)="cellClickedSource($event)"
            [hidden]="!true"
          >
          </ag-grid-angular>
        </div>
      </div>
      <div class="col-lg-6">
        <div
          class="seperateDiv"
          style="overflow: hidden; flex-grow: 1; padding: 0"
        >
          <ag-grid-angular
            class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin"
            style="width: 100%"
            [columnDefs]="columnDefsForTarget"
            [animateRows]="true"
            [defaultColDef]="defaultColDef"
            [suppressPaginationPanel]="true"
            [rowMultiSelectWithClick]="false"
            [rowSelection]="rowSelectionForTarget"
            [rowHeight]="35"
            [headerHeight]="35"
            [enableBrowserTooltips]="true"
            [floatingFiltersHeight]="45"
            [enableRangeSelection]="true"
            [debug]="true"
            (gridReady)="onGridReadyForTargetAttributes($event)"
            (rowSelected)="cellClickedTarget($event)"
            [hidden]="!true"
          >
          </ag-grid-angular>
        </div>
      </div>
      <!-- <div class="col-lg-2"></div> -->
    </div>
    <div class="row">
      <div class="col-lg-3">
    <mat-form-field class="filter" appearance="outline">
      <mat-label i18n="@@targetloginusername">
        Mapping Type
      </mat-label>
      <mat-select formControlName="mappingType" [(ngModel)]="mappingType" (selectionChange)="onMappingTypeChange($event)">
              <mat-option *ngFor="let tempObject of mappingTypeDataDropDown" [value]="tempObject.lookupcode">
                  {{tempObject.lookupvalue}}
              </mat-option>

      </mat-select>
      <mat-error *ngFor="let validation of validation_messages.mappingType">
        <span
          *ngIf="validations_form.get('mappingType').hasError(validation.type) && (validations_form.get('mappingType').dirty || validations_form.get('mappingType').touched)">
          {{ validation.message }}
        </span>
      </mat-error>
  </mat-form-field>
      </div>
      
      <div class="col-lg-3" > 
        <mat-form-field appearance="outline" >
          <mat-label i18n="@@TMSTAFFMASTERfirstname">Codelist Name</mat-label>
            <input
              type="text"
              matInput
              [(ngModel)]="codelistName"
              formControlName="codelistname"
              placeholder="CodeList Name"
              (click)="searchableCodeListName()"
              readonly
            /> 
            <mat-error *ngFor="let validation of validation_messages.codelistname">
              <span
                  *ngIf="validations_form.get('codelistname').hasError(validation.type) && (validations_form.get('codelistname').dirty || validations_form.get('codelistname').touched)">
                  {{ validation.message }}
              </span>
          </mat-error>
        </mat-form-field>
          </div>
         <div class="col-lg-3" *ngIf="mappingType == 'Codelist Mapping' || mappingType == 'Lookup Mapping'">
    <mat-form-field class="filter" appearance="outline">
      <mat-label i18n="@@targetloginusername">
        Default
      </mat-label>
      <mat-select formControlName="codelistValueType" [(ngModel)]="codelistValueType" (selectionChange)="onCodelistDefalutValueTypeChange()">
              <!-- <mat-option value="Source">
                  Source
              </mat-option>
              <mat-option value="Null">
                  Null
              </mat-option> -->
              <!-- <mat-option value="Query">
                  Query
              </mat-option> -->
              <!-- <mat-option value="Constant">
                  Constant
              </mat-option> -->
               <mat-option *ngFor="let tempObject of defult" [value]="tempObject.lookupcode">
                  {{tempObject.lookupvalue}}
              </mat-option>
      </mat-select>
      <mat-error *ngFor="let validation of validation_messages.codelistValueType">
        <span
          *ngIf="validations_form.get('codelistValueType').hasError(validation.type) && (validations_form.get('codelistValueType').dirty || validations_form.get('codelistValueType').touched)">
          {{ validation.message }}
        </span>
      </mat-error>
  </mat-form-field>
      </div>
       <div class="col-lg-3" *ngIf="(mappingType == 'Codelist Mapping' || mappingType == 'Lookup Mapping') && codelistValueType == 'Query'">
            <mat-form-field appearance="outline">
                <mat-label i18n="@@TMshoppingcomplexchooseimage">Query</mat-label>
                <textarea matInput style="height: 20px;" class="file-path validate" placeholder="Query" formControlName="codelistValueTypeQuery" [(ngModel)]="codelistValueTypeQuery" ></textarea>
                  <mat-error *ngFor="let validation of validation_messages.query">
                  <span
                    *ngIf="validations_form.get('codelistValueTypeQuery').hasError(validation.type) && (validations_form.get('codelistValueTypeQuery').dirty || validations_form.get('codelistValueTypeQuery').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
            </mat-form-field>
        </div>
         <div class="col-lg-3" *ngIf="(mappingType == 'Codelist Mapping' || mappingType == 'Lookup Mapping') && codelistValueType == 'Constant'"> 
        <mat-form-field appearance="outline" >
          <mat-label i18n="@@TMSTAFFMASTERfirstname">Constant</mat-label>
            <input matInput formControlName="codelistValueTypeConstant" [(ngModel)]="codelistValueTypeConstant" type="text" placeholder="Constant" >
            <mat-error *ngFor="let validation of validation_messages.codelistValueTypeConstant">
              <span
                  *ngIf="validations_form.get('codelistValueTypeConstant').hasError(validation.type) && (validations_form.get('codelistValueTypeConstant').dirty || validations_form.get('codelistValueTypeConstant').touched)">
                  {{ validation.message }}
              </span>
          </mat-error>
        </mat-form-field>
          </div>
          
          <div class="col-lg-3" *ngIf="mappingType == 'Functional Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference Source Objects</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedReferenceSourceObjectsListNames" (click)="searchableReferenceSourceObjects()"
                    formControlName="selectedReferenceSourceObjectsListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedReferenceSourceObjectsListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedReferenceSourceObjectsListNamesForm').hasError(validation.type) && (validations_form.get('selectedReferenceSourceObjectsListNamesForm').dirty || validations_form.get('selectedReferenceSourceObjectsListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
              
               <div class="col-lg-3" *ngIf="mappingType == 'Functional Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference Transform</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedReferenceTargetObjectsListNames" (click)="searchableReferenceTargetObjects()"
                    formControlName="selectedReferenceTargetObjectsListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedReferenceTargetObjectsListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedReferenceTargetObjectsListNamesForm').hasError(validation.type) && (validations_form.get('selectedReferenceTargetObjectsListNamesForm').dirty || validations_form.get('selectedReferenceTargetObjectsListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
               <div class="col-lg-3" *ngIf="mappingType == 'Functional Mapping'"> 
        <mat-form-field appearance="outline" >
          <mat-label i18n="@@TMSTAFFMASTERfirstname">Reference Value Mapping</mat-label>
          <mat-select
                multiple
                matNativeControl
                [(ngModel)]="selectedReferenceValueMapping"
                formControlName="selectedReferenceValueMappingForm"
              >
                <span  *ngFor="let data of codeListData">
                <mat-option  *ngIf="data.status == 'Yes'"
                  [value]="data.mappingTypeName"
                >
                {{ data.mappingTypeName }}
                </mat-option>
                </span>
               
              </mat-select> 
            <!-- <input matInput formControlName="selectedReferenceValueMappingForm" [(ngModel)]="selectedReferenceValueMappingForm" type="text" placeholder="Codelist Name" > -->
            <mat-error *ngFor="let validation of validation_messages.selectedReferenceValueMappingForm">
              <span
                  *ngIf="validations_form.get('selectedReferenceValueMappingForm').hasError(validation.type) && (validations_form.get('selectedReferenceValueMappingForm').dirty || validations_form.get('selectedReferenceValueMappingForm').touched)">
                  {{ validation.message }}
              </span>
          </mat-error>
        </mat-form-field>
          </div>
           <div class="col-lg-3" *ngIf="mappingType == 'Functional Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference Library Objects</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedReferenceLibraryObjectsListNames" (click)="searchableReferenceLibraryObjects()"
                    formControlName="selectedReferenceLibraryForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedReferenceLibraryForm">
                      <span
                        *ngIf="validations_form.get('selectedReferenceLibraryForm').hasError(validation.type) && (validations_form.get('selectedReferenceLibraryForm').dirty || validations_form.get('selectedReferenceLibraryForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-3" *ngIf="mappingType == 'Functional Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference Global Objects</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedReferenceGlobalObjectsListNames" (click)="searchableReferenceGlobalObjects()"
                    formControlName="selectedReferenceGlobalObjectsListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedReferenceGlobalObjectsListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedReferenceGlobalObjectsListNamesForm').hasError(validation.type) && (validations_form.get('selectedReferenceGlobalObjectsListNamesForm').dirty || validations_form.get('selectedReferenceGlobalObjectsListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
               <div class="col-lg-3" *ngIf="mappingType == 'Functional Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference Global Source Objects</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedReferenceGlobalSourceObjectsListNames" (click)="searchableReferenceGlobalSourceObjects()"
                    formControlName="selectedReferenceGlobalSourceObjectsListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedReferenceGlobalSourceObjectsListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedReferenceGlobalSourceObjectsListNamesForm').hasError(validation.type) && (validations_form.get('selectedReferenceGlobalSourceObjectsListNamesForm').dirty || validations_form.get('selectedReferenceGlobalSourceObjectsListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-3" *ngIf="mappingType == 'Functional Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Global External Objects</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedGlobalExternalObjectsListNames" (click)="searchableGlobalExternalObjects()"
                    formControlName="selectedGlobalExternalObjectsListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedGlobalExternalObjectsListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedGlobalExternalObjectsListNamesForm').hasError(validation.type) && (validations_form.get('selectedGlobalExternalObjectsListNamesForm').dirty || validations_form.get('selectedGlobalExternalObjectsListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div> 
                <div class="col-lg-3" *ngIf="mappingType == 'Functional Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference DB Object Name</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedRefDBObjectNameListNames" (click)="searchableTargetObjectsForRefDBObjectName()"
                    formControlName="selectedRefDBObjectNameListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedRefDBObjectNameListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedRefDBObjectNameListNamesForm').hasError(validation.type) && (validations_form.get('selectedRefDBObjectNameListNamesForm').dirty || validations_form.get('selectedRefDBObjectNameListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>  
              <div class="col-lg-3" *ngIf="mappingType == 'Functional Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference DB Object Fetch Partials</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedRefDBObjectNameFetchPartialsListNames" (click)="searchableTargetObjectsForRefDBObjectNameFetchPartials()"
                    formControlName="selectedRefDBObjectNameFetchPartialsListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedRefDBObjectNameFetchPartialsListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedRefDBObjectNameFetchPartialsListNamesForm').hasError(validation.type) && (validations_form.get('selectedRefDBObjectNameFetchPartialsListNamesForm').dirty || validations_form.get('selectedRefDBObjectNameFetchPartialsListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div> 
               <div class="col-lg-3" *ngIf="mappingType == 'Concat Mapping' ">
                        <mat-form-field appearance="outline">
                            <mat-label i18n="@@TMshoppingcomplexchooseimage">Query</mat-label>
                            <textarea matInput style="height: 20px;" class="file-path validate" placeholder="Query" formControlName="query" [(ngModel)]="query" (change)="createTransformationQueryConcat()" ></textarea>
                             <mat-error *ngFor="let validation of validation_messages.query">
                              <span
                                *ngIf="validations_form.get('query').hasError(validation.type) && (validations_form.get('query').dirty || validations_form.get('query').touched)">
                                {{ validation.message }}
                              </span>
                            </mat-error>
                        </mat-form-field>
                    </div>
              
    </div>
    <div class="row">
          <div class="col-lg-3" *ngIf="mappingType == 'Lookup Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Select Objects</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedStageObjectForMappingType" (click)="searchableObjects()"
                    formControlName="selectStageObjectsForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectStageObjectsForm">
                      <span
                        *ngIf="validations_form.get('selectStageObjectsForm').hasError(validation.type) && (validations_form.get('selectStageObjectsForm').dirty || validations_form.get('selectStageObjectsForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-3" *ngIf="mappingType == 'Lookup Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Select Attributes</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedStageObjectAttributeForMappingType" (click)="searchableAttributes()"
                    formControlName="selectStageObjectsAttributesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectStageObjectsAttributesForm">
                      <span
                        *ngIf="validations_form.get('selectStageObjectsAttributesForm').hasError(validation.type) && (validations_form.get('selectStageObjectsAttributesForm').dirty || validations_form.get('selectStageObjectsAttributesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
                <div class="col-lg-3" *ngIf="mappingType == 'Lookup Mapping'">
                        <mat-form-field appearance="outline">
                            <mat-label i18n="@@TMshoppingcomplexchooseimage">Query</mat-label>
                            <textarea matInput style="height: 20px;" class="file-path validate" placeholder="Query" formControlName="query" [(ngModel)]="query" (change)="createTransformationQuery()" ></textarea>
                             <mat-error *ngFor="let validation of validation_messages.query">
                              <span
                                *ngIf="validations_form.get('query').hasError(validation.type) && (validations_form.get('query').dirty || validations_form.get('query').touched)">
                                {{ validation.message }}
                              </span>
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-3" *ngIf="mappingType == 'Lookup Mapping'">
                       <!--  -->
                      <div style="width: 15%;text-align: end;">
                  <label (click)="addWhere()" style="margin-top: 6px;
                    background: green;
                    margin-bottom: auto;
                    padding: 2px 5px 0px 5px;
                    border-radius: 15px;"><em *ngIf="lookupButtonName =='Save'" class="fas fa-plus" style="color:
                      antiquewhite;font-size: large;" title="Add"></em>
                      <em *ngIf="lookupButtonName =='Update'" class="fas fa-refresh" style="color:
                      antiquewhite;font-size: large;" title="Add"></em>
                    </label>
                </div>
                    </div>
            </div>
        <div class="row" *ngIf="mappingType == 'Lookup Mapping' && lookupMultiList.length > 0">
          <div class="col-lg-9 table-responsive">
             <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
              [columnDefs]="lookupColumnDefs"   [animateRows]="true"
              [pagination]="false" [suppressPaginationPanel]="true" [rowHeight]="35"
              [headerHeight]="35"
              [enableRangeSelection]="false" [debug]="true" [components]="componentsLookup"
              (gridReady)="onGridReadyLookup($event)" [hidden]="!true" style="height: 30vh;margin-bottom: 3%;">
          </ag-grid-angular>
          </div>
        </div>
  </form>
</div>
    <div style="margin-top: 0px">
      
      <form novalidate [formGroup]="validations_form">
        <div class="row topRowMargins" style="margin-bottom: 0;margin-top: 0;">
          <div class="col-lg-12">
            <label
              style="
                font-weight: 500;
                font-size: larger;
                border-bottom: 0.01px ridge coral;
                color: black;
              "
              >Business logic  <span style="font-weight: normal; font-size: medium; color: gray;">(optional)</span></label
            >
            <button i18n="@@CancelButton"
            type="button" id="106" (click)=" generateSQL()"
            class="popup gridColour btn btn-rounded-button z-depth-1
                  waves-effect waves-light text-capitalize"
            [style.background-color]="buttonColor"
            style="font-size: .85rem; margin-top: 12px;margin-left: 2%;
                min-width: 100px; white-space: nowrap; flex: 1;position: relative; z-index: 10;">
            Generate Sql
          </button>
          </div>
        </div>
        <div class="row">
          <!-- <div class="col-lg-2"></div> -->
          <div class="col-lg-12">
 
            <!-- <textarea rows="5" #freetextEditor style="width: 100%; box-sizing: border-box;"></textarea> -->
            <app-code-editor
              [(value)]="freetextDetails "
              [objectsDetails]="selectedSourceAttributeList"
              height="200px"
              (valueChange)="onExpressionChange($event)">
            </app-code-editor>
            <!-- <p *ngIf="syntaxValidOrNot && validationMessage.length > 0" style="font-size: 14px;color: green;">  ✅ {{ validationMessage }}</p>
            <mat-error *ngIf="!syntaxValidOrNot && validationMessage.length > 0" style="font-size: 14px;">{{ validationMessage }}</mat-error> -->
          </div>
          <!-- <div class="col-lg-2">
            <button
            i18n="@@TMRunButton"
            type="button"
            (click)="validateSQL()"
            class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="buttonColor"
            style="
              font-size: 0.85rem;
              width: 100%;
              margin-top: 0px;
            "
          >
            Validate
          </button>
          </div> -->
        </div>
        <div class="row topRowMargins" style="margin-bottom: 0;margin-top: 0;">
          <div class="col-lg-12">
            <label
              style="
                font-weight: 500;
                font-size: larger;
                border-bottom: 0.01px ridge coral;
                color: black;
              "
              >Transformation Expression</label
            >
            <button i18n="@@CancelButton"
            type="button" (click)="openSqlBuilderPopUpForTransformation()"
            class="popup gridColour btn btn-rounded-button z-depth-1
                  waves-effect waves-light text-capitalize"
            [style.background-color]="buttonColor" id="107"
            style="font-size: .85rem; margin-top: 12px;margin-left: 2%;
                min-width: 100px; white-space: nowrap; flex: 1;position: relative; z-index: 10;">
            sql builder
          </button>
          </div>
        </div>
        <div class="row">
          <!-- <div class="col-lg-2"></div> -->
          <div class="col-lg-12">

            <!-- <textarea rows="5" #codeEditor></textarea> -->
              <app-code-editor
              [(value)]="expressionDetails "
              [objectsDetails]="selectedSourceAttributeList"
              height="200px"
              (valueChange)="onExpressionChange($event)">
            </app-code-editor>
            <!-- <p *ngIf="syntaxValidOrNot && validationMessage.length > 0" style="font-size: 14px;color: green;">  ✅ {{ validationMessage }}</p>
            <mat-error *ngIf="!syntaxValidOrNot && validationMessage.length > 0" style="font-size: 14px;">{{ validationMessage }}</mat-error> -->
          </div>
          <!-- <div class="col-lg-2">
            <button
            i18n="@@TMRunButton"
            type="button"
            (click)="validateSQL()"
            class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="buttonColor"
            style="
              font-size: 0.85rem;
              width: 100%;
              margin-top: 0px;
            "
          >
            Validate
          </button>
          </div> -->
        </div>
        <div class="row topRowMargins" style="margin-bottom: 0;">
          <div class="col-lg-12">
            <label
              style="
                font-weight: 500;
                font-size: larger;
                border-bottom: 0.01px ridge coral;
                color: black;
              "
              >Exception Expression</label
            >
            <button i18n="@@CancelButton"
            type="button" (click)="openSqlBuilderPopUpForException()"
            class="popup gridColour btn btn-rounded-button z-depth-1
                  waves-effect waves-light text-capitalize"
            [style.background-color]="buttonColor" id="107"
            style="font-size: .85rem; margin-top: 12px;margin-left: 2%;
                min-width: 100px; white-space: nowrap; flex: 1;position: relative; z-index: 10;">
            sql builder
          </button>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <!-- <textarea rows="5" #codeExceptionEditor></textarea> -->
              <app-code-editor
              [(value)]="exceptionExpressionDetails "
              [objectsDetails]="selectedSourceAttributeList"
              height="200px"
              (valueChange)="onExpressionChange($event)">
            </app-code-editor>
          </div>
        </div>
      </form>
    </div>
    <div class="col-lg">
    <div class="container" style="text-align: center;">
      <!-- <div class="row topRowMargins"> -->
        <span class="example-spacer"></span>
        <div  style=" display: inline-flex; width: 40%; height:fit-content; margin-top: 1rem;" >
          <!-- <button i18n="@@TMRunButton" type="button"
            [style.background-color]="buttonColor"
            class="actionButton btn btn-rounded-button z-depth-1
            waves-effect waves-light text-capitalize" style="padding:
            .3rem 1.6rem;font-size: .85rem;width:100%;" id="101"  (click)="mapAttributes()">{{buttonName}}</button> -->
          <app-common-button style="width: 100%; display: block;" [label]="buttonName" title="Map"
             [buttonId]="101" [critical]="true" width="100%"(clicked)="mapAttributes()">
          </app-common-button>

		  
          <button i18n="@@TMRunButton" type="button"
            [style.border-color]="buttonColor"
            class="cancelButton btn btn-rounded-button z-depth-1
            waves-effect waves-light text-capitalize" style="padding:
            .3rem 1.6rem;font-size: .85rem;width:100%;" (click)="cancel()">Cancel</button>
        </div> 
        <span class="example-spacer"></span>
    </div>
    </div>
    <div>
     <mat-expansion-panel [expanded]="false" style="border-radius: 0.8vh 0.8vh 0 0; box-shadow: none;margin-top: 50px;">
        <mat-expansion-panel-header style="max-height: 50px; background: rgb(228
          227 230 / 41%);border: 1px solid #a9a9a9a8;">
          <mat-panel-title>
            <label style="font-size: 22px; font-weight: 500; margin-top: 10px;"
              i18n="@@spmsUserReg" class="textColour">Verification Execution Status</label>
            <span class="example-spacer"></span>
          </mat-panel-title>
          <mat-panel-description>

          </mat-panel-description>
        </mat-expansion-panel-header>
  <div [style.background-color]="backgroundColorScreen" style="margin-left: -35px; margin-top: -50px;">
      <!-- <div> -->


          <mat-toolbar class="agGridtoperDiv card" style="background: rgb(244 243 245);border-top: 1px solid #a9a9a9a8;border-right: 1px solid #a9a9a9a8;border-left: 1px solid #a9a9a9a8;">

             
              <span class="example-spacer"></span>
              

                 
                  <button class="refreshrunButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Refresh" (click) = "refreshh()">
                      Refresh<em style="padding: 0px 0px 0px 10px;" class="fas fa-refresh" title="Refresh"></em>
                  </button>
                  
                  <div class="insertPageNoDiv">
                      <mat-form-field appearance="outline">
                          <mat-label i18n="@@Targetpageno">Page No</mat-label>
                          <input matInput type="text" (input)="onRunSearchChange($event.target.value)">
                      </mat-form-field>
                  </div>
                  <div class="selectRecordsDiv" style="width:9.5%">
                      <mat-form-field appearance="outline" style="width:100%">
                          <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                          <mat-select  [(ngModel)]="RunpageSize1"  (ngModelChange)="onRunPageSizeChanged(value)">
                              <mat-option value="10" selected>10</mat-option>
                              <mat-option value="200">200</mat-option>
                              <mat-option value="300">300</mat-option>
                              <mat-option value="400">400</mat-option>
                          </mat-select>

                      </mat-form-field>
                  </div>
                  <div class="card pagination paginationFirstButton paginationFirstlastButton">
                      <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onRunBtFirst1()"></em>
                  </div>
                  <div class="card pagination paginationButtons btn-rounded">
                      <ul>
                          <li class="paginationliicon">
                              <em class="fas fa-angle-left waves-effect waves-light" (click)="onRunBtPrevious1()"></em>
                          </li>
                          <li>{{RuncurrentPage1}}/{{RuntotalPages1}}</li>
                          <li class="paginationliicon" style="padding:0;">
                              <em class="fas fa-angle-right waves-effect waves-light" (click)="onRunBtNext1()"></em>
                          </li>
                      </ul>
                  </div>
                  <div class="card pagination paginationLastButton paginationFirstlastButton">
                      <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onRunBtLast1()"></em>
                  </div>

          </mat-toolbar>
      

          <div>

              
            
            <div >
              <ag-grid-angular class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin" 
              style="height: 200px;"
              [columnDefs]="columnDefsExtractTemp" 
              [animateRows]="true"  
              [pagination]="true" 
              [defaultColDef]="defaultColDef" 
              [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" 
              [enableBrowserTooltips]="true" 
              [floatingFiltersHeight]="45"[paginationPageSize]="paginationPageSize" 
              [paginationNumberFormatter]="paginationNumberFormatter" 
              [enableRangeSelection]="true" [debug]="true" 
              [rowClassRules]="rowClassRules" 
              (paginationChanged)="onloadPaginationChanged1()" 
              [components]="components"  
              (gridReady)="retrieveInstructionsBasedOnActivity($event)" 
              [hidden]="!true">

              </ag-grid-angular> 
            </div>

          </div>

  </div>





</mat-expansion-panel>

    </div>
    <div class="row">
      <!-- <div class="col-lg-2"></div>-->
      <div class="col-lg"> 
      <div>
      <mat-toolbar
        class="agGridtoperDiv card"
        style="
          background: rgb(228 227 230 / 41%);
          border-top: 1px solid #a9a9a9a8;
          border-right: 1px solid #a9a9a9a8;
          border-left: 1px solid #a9a9a9a8;
        "
      >
        <label i18n="@@spmsUserReg" class="textColour">Mapped Attributes</label>
        <span class="example-spacer"></span>

        


        <div [hidden]="isvisible">
           <!-- <button class="refreshrunButton popup gridColour btn btn-rounded-button
        z-depth-1 waves-effect waves-light text-capitalize" id="109"
        [style.background-color]="buttonColor"[style.min-width.px]="50" style="padding: 0px;" title='Delete selected attributes' (click)="deleteMultipleAttributes()">
        Delete</button> -->
        <app-common-button  label="Delete" title="Delete selected attributes"
          [buttonId]="109" [critical]="true" width="100px"(clicked)="deleteMultipleAttributes()">
        </app-common-button>
          <!-- <button class="refreshrunButton popup gridColour btn btn-rounded-button
        z-depth-1 waves-effect waves-light text-capitalize"
        [style.background-color]="buttonColor"[style.min-width.px]="50" style="padding: 0px;" title={{ButtonApprove}} id="103" [disabled]="isdisable" (click)="ApproveAttribute()">
        {{ButtonApprove}}</button> -->
       
        <app-common-button  [label]="ButtonApprove" [title]="ButtonApprove" [disabled]="isdisable"
          [buttonId]="103" [critical]="true" width="100px"(clicked)="ApproveAttribute()" style="margin-left: 8px">
        </app-common-button>
        <button class="refreshrunButton popup gridColour btn btn-rounded-button
        z-depth-1 waves-effect waves-light text-capitalize"
        [style.background-color]="buttonColor"  [style.min-width.px]="50" style="padding: 0px;"
  style="font-size: 12px; padding: 0px 0px; height: 30px;" title="View Result" id="104" [disabled]="isdisable" (click)="Viewresults()">
        View Result</button>

        <button class="refreshrunButton popup gridColour btn btn-rounded-button
        z-depth-1 waves-effect waves-light text-capitalize"
        [style.background-color]="buttonColor"[style.min-width.px]="50"  style="padding: 0px;" title="Verify Mapping" id="105" [disabled]="isdisable" (click)="Mappingverify()">
        Verify Mapping</button>
        </div>
        <!-- ========================================================== -->
        
        <!-- <button class="popup gridColour btn btn-rounded-button z-depth-1
                waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" [style.min-width.px]="50"
          style="font-size: 12px; padding: 4px 10px; height: 32px;" id="102" title="Import Data" (click)="importData()">
          Import
          <em class="fas fa-download" style="font-size: 12px; padding: 0 0px;" title="Import Data"></em>
        </button> -->
        <app-common-button  label="Import Data" title="Import Data"
             [buttonId]="102" [critical]="true" width="100px"(clicked)="importData()">
          </app-common-button>
        <!-- Import Button -->
        <button class="popup gridColour btn btn-rounded-button z-depth-1
                                       waves-effect waves-light text-capitalize" [style.background-color]="buttonColor"
          [style.min-width.px]="50" style="font-size: 12px; padding: 4px 10px; height: 32px;" id="201" title="Export Data"
          (click)="exportData()">
          Export
          <em class="fas fa-upload" style="font-size: 12px; padding: 0 0px;" title="Export Data"></em>
        </button>
        
        <!-- ================================================ -->

        <!-- <button 
       
         class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                 [style.background-color]="buttonColor"
                 title="Upload File" id="108"
                 (click)="excelFileUpload()">
           Upload File -->
    <!-- <em style="padding: 0px 0px 0px 10px;" class="fas fa-upload" title="Upload File"></em> -->
     <!-- </button> -->
       <app-common-button  label="Upload File" title="Upload File"
             [buttonId]="108" [critical]="true" width="100px"(clicked)="excelFileUpload()">
          </app-common-button>
        <!-- <button
          class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
          [style.background-color]="buttonColor"
          title="Download"
          (click)="onBtExport()"
          style="font-size: 12px; padding: 4px 10px; height: 32px"
        >Download<em
            class="fas fa-download example-icon"
            style="font-size: 12px; padding: 0 5px"
          ></em>
        </button> -->

        <!-- <div class="insertPageNoDiv">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@spmsUserRegpageno">Page No</mat-label>
            <input
              matInput
              type="text"
              (input)="onSearchChange($event.target.value)"
            />
          </mat-form-field>
        </div> -->

        <div class="selectRecordsDiv" style="width: 8.5%;margin: auto 10px;">
          <mat-form-field appearance="outline" style="width: 90%">
            <mat-label i18n="@@spmsUserRegrecords" style="color: black"
              >Records</mat-label
            >
            <mat-select
              [(ngModel)]="pagesize"
              (ngModelChange)="onPageSizeChanged()"
            >
              <mat-option value="10" selected>10</mat-option>
              <mat-option value="200">200</mat-option>
              <mat-option value="300">300</mat-option>
              <mat-option value="400">400</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div
          class="card pagination paginationFirstButton paginationFirstlastButton"
        >
          <em
            class="fas fa-angle-double-left waves-effect waves-light"
            (click)="onBtFirst()"
          ></em>
        </div>
        <div class="card pagination paginationButtons btn-rounded">
          <ul>
            <li class="paginationliicon">
              <em
                class="fas fa-angle-left waves-effect waves-light"
                (click)="onBtPrevious()"
              ></em>
            </li>
            <li>{{ currentpage }}/{{ totalpages }}</li>
            <li class="paginationliicon" style="padding: 0">
              <em
                class="fas fa-angle-right waves-effect waves-light"
                (click)="onBtNext()"
              ></em>
            </li>
          </ul>
        </div>
        <div
          class="card pagination paginationLastButton paginationFirstlastButton"
        >
          <em
            class="fas fa-angle-double-right waves-effect waves-light"
            (click)="onBtLast()"
          ></em>
        </div>
      </mat-toolbar>
    </div>
    <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
    [columnDefs]="mappedAttributesColumnDefs"  [animateRows]="true"
    [pagination]="true" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35"
    [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
    [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
    [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
    (paginationChanged)="onPaginationChanged()" [components]="components"
    (gridReady)="onMappedAttributesGridReady($event)" [hidden]="!true" style="height: 55vh;">
    </ag-grid-angular>

<div class="row topRowMargins">
  <!-- <div class="col-lg-3"></div>
  <div class="col-lg-6" style="display: flex">
    <button
      i18n="@@TMRunButton"
      type="button"
      (click)="onClickOfCreateBaseline()"
      class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
      [style.background-color]="buttonColor"
      style="padding: .3rem 1.6rem; font-size: .85rem; margin-top: 12px;
        min-width: 150px; white-space: nowrap; flex: 1;position: relative; z-index: 10;
      "
    >
     Create Snapshot
    </button>
    <button i18n="@@CancelButton"
      type="button" (click)="openBaselineView()"
      class="popup gridColour btn btn-rounded-button z-depth-1
            waves-effect waves-light text-capitalize"
      [style.background-color]="buttonColor"
      style="padding: .3rem 1.6rem; font-size: .85rem; margin-top: 12px;
          min-width: 150px; white-space: nowrap; flex: 1;position: relative; z-index: 10;">
      View Snapshot
    </button> -->
    <!-- <button i18n="@@CancelButton"
    type="button" (click)="openSqlBuilderPopUp()"
    class="popup gridColour btn btn-rounded-button z-depth-1
          waves-effect waves-light text-capitalize"
    [style.background-color]="buttonColor"
    style="padding: .3rem 1.6rem; font-size: .85rem; margin-top: 12px;
        min-width: 150px; white-space: nowrap; flex: 1;position: relative; z-index: 10;">
    open sql editor
  </button> -->
  <!-- </div> -->
  <div class="col-lg-3"></div>
</div>
    </div>
    <!-- <div class="col-lg-2"></div> -->
    </div>
  </div>
</div>
